<dialog id="bulk-edit-dialog" #bulkEditDialog (cancel)="handleCancel()">
  <div class="drawer-header">
    <div class="drawer-title">Bulk Student Edit</div>
    <button class="btn-close" type="button" (click)="handleCancel()"></button>
  </div>
  <div class="drawer-body">
    <div class="alert alert-secondary message">
      You are bulk editing properties for {{ this.studentIds().size }} Students
    </div>
    <form [formGroup]="bulkEditForm">
      <div class="field-row">
        <div class="field-title">Teacher</div>
        <div class="field-header">
          <input type="checkbox" id="teacher-update" formControlName="updateTeacher" (change)="toggleField('updateTeacher', 'teacherId')" />
          <label for="teacher-update">Update</label>
        </div>
        <div>
          <ng-select
            bindLabel="displayName"
            bindValue="userID"
            formControlName="teacherId"
            [items]="teachers()"
            [clearable]="false"
          ></ng-select>
          @if (teacherInput?.invalid && (teacherInput?.dirty || teacherInput?.touched)) {
            <div class="help-block small-text">
              <div>
                <fa-icon [icon]="errorIcon" />
                A Teacher must be selected
              </div>
            </div>
          }
        </div>
      </div>
      <div class="field-row">
        <div class="field-title">Class</div>
        <div class="field-header">
          <input type="checkbox" id="class-update" formControlName="updateClass" (change)="toggleField('updateClass', 'schoolClassName')" />
          <label for="class-update">Update</label>
        </div>
        <div>
          <ng-select
            formControlName="schoolClassName"
            [items]="availableClasses()"
            [clearable]="true"
            [addTag]="true"
          ></ng-select>
          @if (classInput?.invalid && (classInput?.dirty || classInput?.touched)) {
            <div class="help-block small-text">
              <div>
                <fa-icon [icon]="errorIcon" />
                A Class must be selected
              </div>
            </div>
          } @else {
            <div class="small-instruction margin-top-5">
              <fa-icon [icon]="infoIcon" />
              A Class can only be set if all Students belong to the same Teacher
            </div>
          }
        </div>
      </div>
      <div class="field-row" [class.locked]="!sessionTimeToggle?.value || sessionTimeToggle?.value === false">
        <div class="field-title">Session Time</div>
        <div class="field-header">
          <input type="checkbox" id="session-update" formControlName="updateSessionTime" (change)="toggleField('updateSessionTime', 'sessionLength')" />
          <label for="session-update">Update</label>
        </div>
        <div class="radio-toggle">
          @for (timeOpt of sessionTimes(); track $index) {
            <label>
              <input type="radio" [value]="timeOpt" formControlName="sessionLength"> {{timeOpt}}
            </label>
          }
          @if (sessionLengthInput?.invalid && (sessionLengthInput?.dirty || sessionLengthInput?.touched)) {
            <div class="help-block small-text">
              <div>
                <fa-icon [icon]="errorIcon" />
                A Session Time must be selected
              </div>
            </div>
          }
        </div>
      </div>
      <div class="field-row" [class.locked]="!extraSupportToggle?.value || extraSupportToggle?.value === false">
        <div class="field-title">Extra Support</div>
        <div class="field-header">
          <input type="checkbox" id="support-update" formControlName="updateExtraSupport" (change)="toggleField('updateExtraSupport', 'extraSupportNeeded')" />
          <label for="support-update">Update</label>
        </div>
        <div class="radio-toggle">
          <label>
            <input type="radio" [value]="true" formControlName="extraSupportNeeded"> Yes
          </label>
          <label>
            <input type="radio" [value]="false" formControlName="extraSupportNeeded"> No
          </label>
          @if (extraSupportInput?.invalid && (extraSupportInput?.dirty || extraSupportInput?.touched)) {
            <div class="help-block small-text">
              <div>
                <fa-icon [icon]="errorIcon" />
                Extra Support must be specified
              </div>
            </div>
          }
        </div>
      </div>
      @if (!this.ssoUser()) {
        <div class="field-row">
          <div class="field-title">Password</div>
          <div class="field-header">
            <input type="checkbox" id="password-update" formControlName="updatePassword" (change)="toggleField('updatePassword', 'password')" />
            <label for="password-update">Update</label>
          </div>
          <div>
            <input type="text" class="padding-top-5 padding-bottom-5 padding-left-10 padding-right-10 full-screen-width" formControlName="password" />
            @if (passwordInput?.invalid && (passwordInput?.dirty || passwordInput?.touched)) {
              <div class="help-block small-text">
                <div>
                  <fa-icon [icon]="errorIcon" />
                  A password must be 5 to 50 characters long and include at least one number
                </div>
              </div>
            }
          </div>
        </div>
      }
    </form>
  </div>
  @if (saveError()) {
    <div class="alert alert-danger message margin-left-10 margin-right-10">
      <div class="icon">
        <fa-icon [icon]="errorIcon" />
      </div>
      <div>
        <div class="bold">Error Saving Updates</div>
        <div>{{saveError()}}</div>
      </div>
    </div>
  }
  <div class="drawer-footer">
    <button
      class="btn btn-success"
      (click)="handleSave()"
      [disabled]="isSaving() || !hasPropsToUpdate() || bulkEditForm.invalid"
    >
      @if (isSaving()) {
        <fa-icon [icon]="loadingIcon" [spin]="true" />
        Saving Changes...
      } @else {
        Save Changes
      }
    </button>
  </div>
</dialog>
